module.exports = __webpack_public_path__ + "static/nature.55a3ea06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surroundings/nature.jpg
// module id = 417
// module chunks = 23221215298982